import produce from 'immer';
import {
  AUTHGROUP_LIST_REQUEST,
  CREATE_ACCOUNT,
  DEPARTMENT_LSIT_REQUEST,
  EMAIL_CHECK,
  MANAGER_INFO_REQUEST,
  MANAGER_INFO_UPDATE,
  MANAGER_LIST_REQUEST, MANAGER_RESPONSE_MESSAGE,
  MANAGER_SECEDE, MANAGER_TERMINATE_SESSION,
  REMOVE_TWOFACTOR,
  RND_CHANGE_PASSWORD,
  SET_AUTHGROPUN_LIST,
  SET_DEPARTMENT_LIST,
  SET_EMAIL_EXISTS,
  SET_MANAGER_INFO,
  SET_MANAGER_LIST, SET_MANAGER_PAGINATION,
  SET_TOTAL_COUNT
} from '../../constants/backoffice/managerConstants';

const initialState = {
  managerList: [],
  info: null,
  authGroupList: [],
  departmentList: [],
  emailExists: null,
  page: 1,
  pageLength: 10,
  totalCount: 0,
  searchString: '',
  resultCode: null,
  checkCode: null,
  message: null
};

/* eslint-disable default-case, no-param-reassign */
const managerReducer = (state = initialState, action = {}) => produce(state, draft => {
  switch (action.type) {
    case MANAGER_SECEDE:
    case MANAGER_INFO_UPDATE:
    case REMOVE_TWOFACTOR:
    case RND_CHANGE_PASSWORD:
    case CREATE_ACCOUNT:
    case EMAIL_CHECK:
    case DEPARTMENT_LSIT_REQUEST:
    case AUTHGROUP_LIST_REQUEST:
    case MANAGER_INFO_REQUEST:
    case MANAGER_LIST_REQUEST:
      break;
    case SET_MANAGER_LIST:
      draft.managerList = action.list;
      break;
    case SET_TOTAL_COUNT:
      draft.totalCount = action.totalCount;
      break;
    case SET_MANAGER_INFO:
      draft.detailInfo = action.info;
      break;
    case SET_AUTHGROPUN_LIST:
      draft.authGroupList = action.list;
      break;
    case SET_DEPARTMENT_LIST:
      draft.departmentList = action.list;
      break;
    case SET_EMAIL_EXISTS:
      draft.emailExists = action.emailExists;
      draft.checkCode = action.resultCode;
      break;
    case SET_MANAGER_PAGINATION:
      draft.page = action.page;
      draft.totalCount = action.totalCount;
      draft.searchString = action.searchString;
      break;
    case MANAGER_RESPONSE_MESSAGE:
      draft.resultCode = action.resultCode;
      draft.message = action.message;
      break;
    case MANAGER_TERMINATE_SESSION:
      // draft.managerNo = action.managerNo;
      break;
    default:
      break;
  }
});

export default managerReducer;
